import React, { forwardRef } from 'react';
import { styleIcon } from '../style_icon.js';
export const OpenNewBrowserIcon = forwardRef(({ title = 'Open New Browser Icon', ...rest }, ref) => {
    const props = styleIcon(rest);
    return (React.createElement("svg", { ...props, ref: ref, viewBox: "0 0 14 14" },
        !props['aria-hidden'] && React.createElement("title", null, title),
        React.createElement("path", { d: "M13.5 0H.5a.5.5 0 0 0-.5.5v13c0 .28.22.5.5.5h13a.5.5 0 0 0 .5-.5V.5a.5.5 0 0 0-.5-.5M12 6.55c0 .28-.34.42-.54.22l-1.6-1.6L7.14 7.9a.37.37 0 0 1-.51 0l-.52-.52a.37.37 0 0 1 0-.51l2.72-2.72-1.6-1.6A.31.31 0 0 1 7.45 2h4.24c.17 0 .31.14.31.31z" })));
});
//# sourceMappingURL=open_new-browser_icon.js.map